import React from 'react'
import Attachment from "../../../../../model2/attachment/attachment";
import {AttachmentSystemType} from "../../../../../model2/attachment/@types";

type Props = {
    attachment    : Attachment
    className?    : string
    isCustom?     : boolean
}

export default function AttachmentButtonOpenNewWindow(props: Props):any {

    if (!props.attachment) return false

    const onClick = (e: any) => {
        e.stopPropagation()

        if(props.attachment?.systemType === AttachmentSystemType.CUSTOM){
            props.attachment.openByFileObject()
        }
        else{
            props.attachment.openInBrowser()
        }
    }

    const classes = Classes("ui5-ico-round i5-open-new-window", props.className)

    return <div className   = {classes}
                onClick     = {onClick} />
}
